import request from '@/libs/request';
// 站内信 ------------------

// 查看站内信列表
export const GetInMailList = (data) => request('GetInMailList', data);

// 新建站内信
export const CreateInMail = (data) => request('CreateInMail', data);

// 查看站内信详情
export const GetInMailDetail = (data) => request('GetInMailDetail', data);

// 更新站内信
export const UpdateInMail = (data) => request('UpdateInMail', data);

// 发布站内信
export const PubInMailById = (data) => request('PubInMailById', data);

// 删除站内信
export const DelInMail = (data) => request('DelInMail', data);

// 撤回站内信
export const WithdrawInMailById = (data) => request('WithdrawInMailById', data);
